<template lang="pug">
    
div(
    ref="containerRef"
)
    transition(
        mode="out-in"
        :duration="duration"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
    )
        slot
    
</template>

<script lang="ts">
import Vue, { onMounted, ref } from 'vue'

import toRem from '@/shared/lib/utils/default/toRem'

export default Vue.extend({
    name: 'AnimatedTransition',
    setup() {
        const duration = ref(200)
        const containerRef = ref()

        onMounted(() => {
            containerRef.value.style.transition = `height ${duration.value}ms ease`
        })

        function getHeight(el: HTMLElement) {
            return el?.getBoundingClientRect()?.height ?? null
        }

        function beforeEnter() {
            // el.style.opacity = '0'
        }

        function enter(el: HTMLElement) {
            const delay = duration.value / 2

            el.style.opacity = '0'
            el.style.transition = `opacity ${duration.value}ms ${delay}ms ease`

            setTimeout(() => {
                const height = getHeight(el)
                containerRef.value.style.height = `${toRem(height)}rem`
                el.style.opacity = '1'
            }, 1)
        }

        function leave(el: HTMLElement) {
            el.style.opacity = '1'
            el.style.transition = `opacity ${duration.value}ms ease`

            setTimeout(() => {
                el.style.opacity = '0'
            }, 1)
        }

        return {
            containerRef,
            duration,
            beforeEnter,
            enter,
            leave,
        }
    },
})
</script>

<!--<style module lang="scss">-->
<!--.root {-->
<!--    transition: height 2s ease;-->
<!--}-->
<!--</style>-->
